import fetch from "lib/fetch";
import type { ReportAdInterface, ReportAdPayload, ReportAdStatusInterface } from "types/reportAd";

type ReportAdResponse = { data: ReportAdInterface };
type ReportAdStatusResponse = { data: ReportAdStatusInterface };

export const createReportAdRequest = (adId: string, data: ReportAdPayload) =>
    fetch.post<ReportAdResponse>(`report_ad/${adId}`, data);

export const getReportAdStatusRequest = (adId: string) =>
    fetch.get<ReportAdStatusResponse>(`report_ad/${adId}/status`);
